interface RouteTooltipProps {
  visible: boolean;
  x: number;
  y: number;
}

export const RouteTooltip = ({ visible, x, y }: RouteTooltipProps) => {
  if (!visible) return null;

  return (
    <div
      className="pointer-events-none absolute z-50 rounded bg-black/50 px-2 py-1 text-sm text-white shadow-md"
      style={{
        left: x,
        top: y,
        transform: "translate(-50%, -50%)",
      }}
    >
      <p className="text-xs">Click to start route</p>
    </div>
  );
};
